import axios from "axios";

// Sends a request/contact form to admin-ajax and goes to the thank-you page.
// The server saves every entry before mailing, so only show an error when it really failed.
export const initAjaxForm = (form, action, thankYouUrl) => {
    const responseTag = form.parentElement.querySelector('#response');

    form.addEventListener('submit', function(e) {
        e.preventDefault();

        // Ignore double clicks while it's sending
        if (form.classList.contains('sending')) {
            return
        }

        form.classList.add('sending')
        responseTag.innerHTML = ''

        const formData = new FormData(form);
        formData.append('action', action);

        axios.post(ajaxUrl, formData, { timeout: 30000 })
            .then(function(response) {
                if (response.data && response.data.success === false) {
                    throw response
                }

                window.location.href = thankYouUrl
            })
            .catch(function(error) {
                const data = (error.response || error).data
                const message = data && data.data && data.data.message
                    ? data.data.message
                    : 'Your message could not be sent. Please try again, or email us at <a href="mailto:contact@premiumbiketours.com">contact@premiumbiketours.com</a>.'

                responseTag.innerHTML = '<p>' + message + '</p>';
                form.classList.remove('sending')
            });
    });
}
